import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import EmptyActiveVehiclePlaceholder from '../VehicleSection/components/EmptyActiveVehiclePlaceholder'
import EmptyVehiclePlaceholder from '../VehicleSection/components/EmptyVehiclePlaceholder'
import VehicleSection from '../VehicleSection'

const BOTGarageVehicles = ({
  editVehicleToolTip,
  makeActiveVehicle,
  addNewVehicle,
  serviceHistoryLink: {
    path
  } = {},
  UserVehicleDetails: {
    userVehicle,
    noOfVehicles
  } = {},
  isShowVehiclePlaceholder,
  gridTemplateAreas
}) =>
  <VehiclesGrid
    noOfVehicles={ noOfVehicles }
    gridTemplateAreas={ gridTemplateAreas }
    userVehicle={ userVehicle } >

    { isShowVehiclePlaceholder && <EmptyVehiclePlaceholder handleAddNewVehicle={ addNewVehicle } /> }
    { noOfVehicles
      ? userVehicle.map(({ userVehicleId, ...props }) =>
        <VehicleSection
          key={ userVehicleId }
          { ...props }
          serviceHistoryUrl={ path }
          userVehicleId={ userVehicleId }
          editVehicleToolTip={ editVehicleToolTip }
          makeActiveVehicle={ makeActiveVehicle }
          noOfVehicles={ noOfVehicles } />)
      : <EmptyActiveVehiclePlaceholder handleAddNewVehicle={ addNewVehicle } />
    }
  </VehiclesGrid>

BOTGarageVehicles.propTypes = {
  addNewVehicle: PropTypes.func,
  editVehicleToolTip: PropTypes.string,
  gridTemplateAreas: PropTypes.shape(),
  isShowVehiclePlaceholder: PropTypes.bool,
  makeActiveVehicle: PropTypes.func,
  myAppointmentsCartridge: PropTypes.shape(),
  serviceHistoryLink: PropTypes.shape({
    path: PropTypes.string
  }),
  showPersonalizeSuccessMessage: PropTypes.bool,
  UserVehicleDetails: PropTypes.shape({
    noOfVehicles: PropTypes.number,
    status: PropTypes.shape(),
    userVehicle: PropTypes.arrayOf(PropTypes.shape())
  })
}

export default BOTGarageVehicles

const VehiclesGrid = styled.div`
  grid-area: VehiclesGrid;
  display: grid;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  ${(props) => !props.noOfVehicles && css`
    grid-template-columns: minmax(200px, 1fr);
    grid-template-areas: ${props.gridTemplateAreas.vehiclesGridNoVehicles.desktop};

    @media (max-width: 1384px) {
      grid-template-areas: ${props.gridTemplateAreas.vehiclesGridNoVehicles.laptop};
    }

    @media (max-width: 1023px) {
      grid-template-areas: ${props.gridTemplateAreas.vehiclesGridNoVehicles.mobile};
    }
  `}
  ${(props) => props.noOfVehicles && css`
    grid-template-columns: repeat(2, minmax(200px, 1fr));
    grid-template-areas: ${props.gridTemplateAreas.vehiclesGridWithVehicles.desktop};
    grid-template-rows: 330px 250px;

    @media (max-width: 1384px) {
      grid-template-areas: ${props.gridTemplateAreas.vehiclesGridWithVehicles.laptop};
      grid-template-columns: minmax(200px, 1fr);
      grid-template-rows: 1fr;
      align-self: self-start;
    }

    @media (max-width: 1023px) {
      grid-template-areas: ${props.gridTemplateAreas.vehiclesGridWithVehicles.mobile};
    }
  `}
`
